import TopicAbout from './TopicAbout';

export default TopicAbout;
